import styled from 'styled-components';

export const Package = styled.div`
  width: 480px;
  height: 650px;
  background-color: #151515;
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin-right: 32px; */
  /* margin-bottom: 28px; */
  border-radius: 2px;
  box-shadow: 10px 10px 64px #0a0a0a;
`;

export const CheckedItem = styled.h3`
  font-style: italic;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 1em;

  i {
    color: ${(props) => props.color};
    font-size: 28px;
  }

  span {
    margin-left: 12px;
  }
`;

export const Text = styled.span`
    font-size: ${props => props.fontSize};
    color: ${props => props.color};
    font-style: italic;
    font-family: "Roboto Condensed";
    font-weight: bold;
    text-transform: uppercase;
    text-align: ${props => props.align};
    display: block;
`

export const Section = styled.div`
    height: ${props => props.height};
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: ${props => props.justify};
    align-items: ${props => props.align};
`

export const Divider = styled.span`
    height: 2px;
    width: 100%;
    background-color: #3b3b3b;
`

export const Button = styled.button`
    width: 100% !important;
    height: 54px !important;
    background: ${props => props.background};
    color: #000;
`




// WEBPACK FOOTER //
// ./src/components/PaymentPackage/PaymentPackage.styles.tsx